module.exports = __webpack_public_path__ + "static/media/S17_B.2df263ab.png";